module.exports = __webpack_public_path__ + "img/Kyzylorda.c5f4ed69.png";